import { ICoupon, IEvaluationFeedback, Rule } from '@rbi-ctg/offers';
import { ICartInput, buildCartInput } from 'utils/cart';
import { redeemedOnTime } from 'utils/offers';

import { QUERY_TYPE } from '../constants';
import { OfferError } from '../exceptions';
import { isOfferRedeemable, offerRedemptions } from '../queries/offers';

interface IListCouponsResponse {
  listCoupons: {
    count: number;
    coupons: ICoupon[];
    resumeAfter: string;
  };
}

export const getOfferRedemptions = ({ includeRedeemed = true } = {}) => {
  return {
    queryType: QUERY_TYPE.LambdaGraphqlQuery,
    query: offerRedemptions,
    variables: {
      includeRedeemed
    },
    catch: (e: Error) => {
      // TODO: Design an error order state
      throw new OfferError('An error occurred loading offer redemptions', e);
    },
    then: (result: IListCouponsResponse) => result.listCoupons
  };
};

interface IRedeemCouponResponse {
  redeemCoupon: {
    couponId: string;
    redeemedOn: string;
  };
}

interface IIsOfferRedeemableInput {
  cart?: ICartInput | null;
  couponId: string;
  rbiOrderId?: string | null;
  redeemedOn?: string | null;
  ruleSet?: Rule[] | null;
}

interface IIsOfferRedeemableResponse {
  isCouponRedeemable: {
    evaluationFeedback: IEvaluationFeedback[];
    isRedeemable: boolean;
  };
}

export const checkIsOfferRedeemable = ({
  cart = null,
  couponId,
  rbiOrderId = null,
  redeemedOn = redeemedOnTime(),
  ruleSet = null
}: IIsOfferRedeemableInput) => {
  return {
    queryType: QUERY_TYPE.LambdaGraphqlQuery,
    query: isOfferRedeemable,
    variables: {
      cart: cart && buildCartInput(cart),
      couponId,
      rbiOrderId,
      redeemedOn,
      ruleSet
    },
    catch: (e: Error) => {
      // TODO: Design an error order state
      throw new OfferError('An error occurred evaluating offers', e);
    },
    then: (result: IIsOfferRedeemableResponse) => result.isCouponRedeemable
  };
};
